<template>
  <section class="section">
    <div class="tabs is-hidden-touch">
      <div
        class="tab"
        v-for="tab in tabs"
        :key="`tab-${tab.text}`"
        @click="toView(tab.pathName)"
      >
        {{ tab.text }}
        <div class="current-module" v-show="$route.name == tab.pathName"></div>
      </div>
    </div>
    <div class="tabs is-hidden-desktop">
      <div class="tab tab--mobile">
        {{ actualTab }}
        <div class="current-module"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TabModules",
  data() {
    return {
      tabs: [
        {
          text: "Ventas",
          pathName: "sales"
        },
        {
          text: "Cotizaciones",
          pathName: "marketrates"
        },
        {
          text: "Guía de Remisión",
          pathName: "referralguide"
        },
        {
          text: "Clientes y Proveedores",
          pathName: "client-provider"
        },
        {
          text: "Gastos y Compras",
          pathName: "expenses-purchases"
        },
        {
          text: "Inventario",
          pathName: "inventory"
        },
        {
          text: "Reportes",
          pathName: "reports"
        }
      ]
    };
  },
  computed: {
    actualTab() {
      return this.tabs.filter(t => t.pathName === this.$route.name)[0].text;
    }
  },
  methods: {
    toView(pathName) {
      this.$router.push({ name: pathName });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/general.scss";
.section {
  padding-bottom: 0px !important;
  @include laptop() {
    margin-bottom: 2em;
  }
}
.tabs {
  margin: 0px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  // display: none;
  // flex-flow: row nowrap;
  // justify-content: flex-start;
  // align-items: center;
  // margin-bottom: 2rem;
  // @media (min-width: 900px) {
  //   display: flex;
  // }
  .tab {
    border-bottom: 5px solid transparent;
    // margin: 1rem 1.5rem;
    font-weight: 400;
    font-size: 14px;
    width: fit-content;
    margin: 0 1em;
    cursor: pointer;
    position: relative;
    padding-bottom: 30px;
    &--mobile {
      text-align: center;
      margin: 0 auto 0.5em;
      font-size: 20px;
    }
    &--active {
      border-bottom-color: $primary;
    }
    .current-module {
      // border-bottom: 7.5px solid $primary;
      position: absolute;
      right: calc(50% - 52.5px);
      bottom: 12px;
      height: 7px;
      width: 105px;
      background-color: $primary;
    }
    @media (min-width: 1024px) {
      font-size: 16px;
    }
    @media (min-width: 1200px) {
      font-size: 20px;
    }
    @media (min-width: 1800px) {
      font-size: 1.4rem;
    }
  }
}
</style>
